export default function themePalette(theme) {
  return {
    primary: {
      light: theme.colors?.primaryLight,
      main: theme.colors?.primaryMain,
      dark: theme.colors?.primaryDark,
      500: theme.colors?.primary500,
      400: theme.colors?.primary400
    },
    secondary: {
      light: theme.colors?.secondaryLight,
      main: theme.colors?.secondaryMain,
      dark: theme.colors?.secondaryDark,
      500: theme.colors?.secondary400,
      400: theme.colors?.secondary400
    },
    grey: {
      light: theme.colors?.greyLight,
      main: theme.colors?.greyMain,
      dark: theme.colors?.greyDark,
      500: theme.colors?.grey500,
      400: theme.colors?.grey400,
      contrastText: theme.colors?.greyContrastText
    },
    white: {
      main: theme.colors?.whiteMain
    }
  };
}
